// removed by extract-text-webpack-plugin
module.exports = {"scroll-box":"Legal__scroll-box__1u17e","questions":"Legal__questions__2tDrN","legal":"Legal__legal__33PvZ","legal-mobile":"Legal__legal-mobile__mtXCK","header":"Legal__header__kE74X","line-items":"Legal__line-items__2zU7S"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Legal/Legal.scss
// module id = 61
// module chunks = 0